import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '../../ea/globals.js'
import * as lightbox from '../../lightboxes/lightbox.js'
import * as utilities from '../../styles.js'
import rte from '../rte.js'

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: (
    button
  ) => {
    const container = closest(`.${utilities.elements.modal}`, button)
    const origin = lightbox.opener(container)
    const form = one('form', container)
    const mainForm = closest('form', origin)
    const rte = one('iframe[data-rte]', mainForm)

    if (rte && rte.id) {
      globals.ea_rte_exec_insert_table(rte.id, form)
    }

    const anchor = one('[data-contract="modal.close"] ', container)

    if (anchor) {
      anchor.click()
    }
  }
})

export const highlight = (
  button,
  modifier,
  text
) => {
  if (closest('table', text)) {
    button.classList.add(modifier)
  }
}

export default button => {
  onClick.listen(button)
  rte(button, object(null, { highlight }))
}
